module.exports = __webpack_public_path__ + "static/media/drop-media-9@1x.31a1c2f1.png";